import axios from 'axios';
import { API } from './api';

let currentPage = null;

export const trackPageView = async (pageName) => {
  // Don't track duplicate views of the same page
  if (currentPage === pageName) {
    return;
  }
  
  currentPage = pageName;
  
  try {
    await axios.post(`${API}/admin/track-page-view`, {
      page_name: pageName,
      user_agent: navigator.userAgent,
      session_info: {
        screen_width: window.screen.width,
        screen_height: window.screen.height
      }
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience if tracking fails
    console.debug('Page view tracking failed:', error);
  }
};

// Reset on logout
export const resetPageTracking = () => {
  currentPage = null;
};
